<template>
  <div class="row position-relative">
    <div class="col-md-3 ribbon">
      <span class="ribbon3 text-center">
        <span>{{ this.title }}</span>
      </span>
    </div>
    <div class="col-md ml-auto">
      <button
        v-b-tooltip.hover="'بازگشت به صفحه قبلی'"
        @click="$router.back()"
        class="float-right position-absolute"
        style="left: 3rem; z-index: 1; top: 1.8rem"
      >
        <i class="fa fa-times text-danger"></i>
      </button>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "titleRibbon",
  props: {
    title: {
      default: "مدیریت آگهی تبلیغاتی",
    },
  },
};
</script>

<style scoped>
.ribbon {
  width: 100%;
  float: right;
  margin-bottom: 0;
  text-transform: uppercase;
  color: white;
  z-index: 1;
}

.ribbon:nth-child(even) {
  margin-right: 4%;
}

@media (max-width: 500px) {
  .ribbon {
    width: 100%;
  }

  .ribbon:nth-child(even) {
    margin-right: 0%;
  }
}

.ribbon3 {
  width: 200px;
  height: 50px;
  line-height: 50px;
  padding-left: 15px;
  position: absolute;
  right: -1px;
  top: 30px;
  background: rgb(238, 49, 138);
}

.ribbon3:before,
.ribbon3:after {
  content: "";
  position: absolute;
}

.ribbon3:before {
  height: 0;
  width: 0;
  top: -7.5px;
  right: 0;
  border-bottom: 9px solid black;
  border-left: 9px solid transparent;
}

.ribbon3:after {
  height: 0;
  width: 0;
  left: -14.5px;
  border-top: 25px solid transparent;
  border-bottom: 25px solid transparent;
  border-right: 15px solid rgb(238, 49, 138);
}
</style>
